import { useState, useEffect } from 'react'
import type {Tab} from "../src/Tabs/Tabs";

export function useTabIndex(tabsMapping: Record<number, string>, tab?: string) {
  const [currentTab, setCurrentTab] = useState(0)

  useEffect(() => {
    const tabIndex =
      Object.keys(tabsMapping)
        .map(Number)
        .find((key: number) => tabsMapping[key] === tab) || 0
    tab && setCurrentTab(tabIndex)
  }, [tabsMapping, tab])

  return currentTab
}


export function usePathTab(tabMapping: Record<string, Tab>, currentPathSegment?: string) {
  if (currentPathSegment && tabMapping[currentPathSegment] !== undefined && tabMapping[currentPathSegment].visible) {
    return tabMapping[currentPathSegment].index
  }

  return 0;
}
